import { useMemo } from 'react'

import FormContextProvider from '@space-shell/common/hooks/useForm/useForm'

import CommunityModalContent from './communityModalContent'

import { useGetCommunity } from '../../hooks'
import { formFields } from '../constants'
import type { CommunityModalProps, FormFields } from '../types'

const CommunityModal = (props: CommunityModalProps) => {
  const { communityData, isLoadingCommunityData } = useGetCommunity(props.communityId)

  const fields = useMemo(() => {
    const groupId = communityData?.idGroup
      ? communityData?.idGroup
      : props.groupId !== undefined
      ? props.groupId
      : formFields.idGroup.value

    return {
      description: {
        name: formFields.description.name,
        value: communityData?.description ?? formFields.description.value
      },
      icon: {
        name: formFields.icon.name,
        value: communityData?.icon ?? formFields.icon.value
      },
      idGroup: {
        name: formFields.idGroup.name,
        value: groupId
      },
      name: {
        name: formFields.name.name,
        value: communityData?.name ?? formFields.name.value
      },
      communityType: {
        name: formFields.communityType.name,
        value: communityData?.type ?? formFields.communityType.value
      },
      collaborativeContent: {
        name: formFields.collaborativeContent.name,
        value: communityData?.isCollaborative ?? formFields.collaborativeContent.value
      },
      defaultEnableComments: {
        name: formFields.defaultEnableComments.name,
        value: communityData?.isDefaultEnableComments ?? formFields.defaultEnableComments.value
      },
      hide: {
        name: formFields.hide.name,
        value: communityData?.isHide ?? formFields.hide.value
      },
      moderationCommunity: {
        name: formFields.moderationCommunity.name,
        value: communityData?.isModerationCommunity ?? formFields.moderationCommunity.value
      }
    }
  }, [communityData, props.groupId])

  if (isLoadingCommunityData) return null

  return (
    <FormContextProvider<FormFields> formFields={fields}>
      <CommunityModalContent {...props} communityName={communityData?.name} />
    </FormContextProvider>
  )
}

export default CommunityModal
